<template>
    <ContentCard>
        <div class="manage">
            <DirectDebitOverview v-if="accountName" :accountname="accountName" browse="" />
        </div>
    </ContentCard>
</template>

<script>
    // @ is an alias to /src
    import DirectDebitOverview from "@/components/DirectDebitOverview.vue";

    import beeet from "@/beet";
    import ContentCard from "../components/ContentCard";

    export default {
        name: "manage",
        components: {
            ContentCard,
            DirectDebitOverview
        },
        data() {
            return {
                beet: beeet,
                accountName: null
            }
        },
        mounted() {
            console.log(this.$route);
            if (this.$route.params.accountname) {
                this.accountName = this.$route.params.accountname;
            } else if (this.beet.getCurrentConnection()) {
                this.accountName = this.beet.getCurrentConnection().getAccount().name;
            }
            if (!this.accountName) {
                this.$router.push({name: "login", params: {next: "manage"}});
            } else if (!this.$route.params.accountname) {
                this.$router.push({path: "manage/" + this.accountName});
            }

        }
    };
</script>
